import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import Faqs from "./Component/Faqs";
import Cookies from "./Component/Cookies";
import PaymentResult from "./Component/PaymentResult";
import { LegalPolicy, PolicyCenter } from "./Component/PolicyCenter";

function App() {
  return (
    <CartProvider>
      <Router
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <div className="app-shell">
          <Header />
          <div className="app-content">
            <Routes>
              <Route path="/about" element={<About />} />
              <Route path="/shipping" element={<Delivery />} />
              <Route path="/" element={<Main />} />
              <Route path="/returns" element={<Returns />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/policies" element={<PolicyCenter />} />
              <Route path="/policies/:policySlug" element={<LegalPolicy />} />
              <Route path="/faqs" element={<Faqs />} />
              <Route path="/payment" element={<PaymentResult />} />
              <Route path="/shopDetails/:id" element={<ProductDetail />} />
              <Route path="/cartpage" element={<CartPage />} />
              <Route path="/checkout" element={<CheckOut />} />
              <Route path="/paysuccess" element={<PaySuccess />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
